// FETCH ALL GENERAL_PO INWARD
export const FETCH_GENERAL_DC_INWARD_MASTER_REQUEST = 'FETCH_GENERAL_DC_INWARD_MASTER_REQUEST';
export const FETCH_GENERAL_DC_INWARD_MASTER_SUCCESS = 'FETCH_GENERAL_DC_INWARD_MASTER_SUCCESS';
export const FETCH_GENERAL_DC_INWARD_MASTER_FAILURE = 'FETCH_GENERAL_DC_INWARD_MASTER_FAILURE';

// CREATE GENERAL_PO INWARD
export const CREATE_GENERAL_DC_INWARD_MASTER_REQUEST = 'CREATE_GENERAL_DC_INWARD_MASTER_REQUEST';
export const CREATE_GENERAL_DC_INWARD_MASTER_SUCCESS = 'CREATE_GENERAL_DC_INWARD_MASTER_SUCCESS';
export const CREATE_GENERAL_DC_INWARD_MASTER_FAILURE = 'CREATE_GENERAL_DC_INWARD_MASTER_FAILURE';

// UPDATE GENERAL_PO INWARD
export const UPDATE_GENERAL_DC_INWARD_MASTER_REQUEST = 'UPDATE_GENERAL_DC_INWARD_MASTER_REQUEST';
export const UPDATE_GENERAL_DC_INWARD_MASTER_SUCCESS = 'UPDATE_GENERAL_DC_INWARD_MASTER_SUCCESS';
export const UPDATE_GENERAL_DC_INWARD_MASTER_FAILURE = 'UPDATE_GENERAL_DC_INWARD_MASTER_FAILURE';

// FETCH SINGLE STATE OF GENERAL_PO INWARD
export const FETCH_SINGLE_GENERAL_DC_INWARD_MASTER_REQUEST = 'FETCH_SINGLE_GENERAL_DC_INWARD_MASTER_REQUEST';
export const FETCH_SINGLE_GENERAL_DC_INWARD_MASTER_SUCCESS = 'FETCH_SINGLE_GENERAL_DC_INWARD_MASTER_SUCCESS';
export const FETCH_SINGLE_GENERAL_DC_INWARD_MASTER_FAILURE = 'FETCH_SINGLE_GENERAL_DC_INWARD_MASTER_FAILURE';

// DELETE GENERAL_PO INWARD
export const DELETE_GENERAL_DC_INWARD_MASTER_REQUEST = 'DELETE_GENERAL_DC_INWARD_MASTER_REQUEST';
export const DELETE_GENERAL_DC_INWARD_MASTER_SUCCESS = 'DELETE_GENERAL_DC_INWARD_MASTER_SUCCESS';
export const DELETE_GENERAL_DC_INWARD_MASTER_FAILURE = 'DELETE_GENERAL_DC_INWARD_MASTER_FAILURE';

export const RESET_GENERAL_DC_INWARD_MASTER_INFO = 'RESET_GENERAL_DC_INWARD_MASTER_INFO';

export const CREATE_GENERAL_DC_INWARD_MASTER_FORM = 'CREATE_GENERAL_DC_INWARD_MASTER_FORM';

export const UPDATE_GENERAL_DC_INWARD_MASTER_FORM = 'UPDATE_GENERAL_DC_INWARD_MASTER_FORM';

// NAVIGATE TO PARTY DETAILS COMPONENT
export const NAVIGATE_GENERAL_DC_INWARD_DETAILS = 'NAVIGATE_GENERAL_DC_INWARD_DETAILS';

// NAVIGATE TO GENERAL_PO INWARD COMPONENT
export const NAVIGATE_GENERAL_DC_INWARD_MASTER = 'NAVIGATE_GENERAL_DC_INWARD_MASTER';


export const GENERAL_DC_INWARD_USERFORM_RESET = 'GENERAL_DC_INWARD_USERFORM_RESET';

export const SET_PENDING_GRID_NAME_GENERAL_DC_INWARD = 'SET_PENDING_GRID_NAME_GENERAL_DC_INWARD';

export const SET_UNIT_NAME_GENERAL_DC_INWARD = 'SET_UNIT_NAME_GENERAL_DC_INWARD';
export const SET_START_DATE_GENERAL_DC_INWARD = 'SET_START_DATE_GENERAL_DC_INWARD';
export const SET_END_DATE_GENERAL_DC_INWARD = 'SET_END_DATE_GENERAL_DC_INWARD';

export const FETCH_PENDING_GENERAL_DC_IN_INWARD_REQUEST = 'FETCH_PENDING_GENERAL_DC_IN_INWARD_REQUEST';
export const FETCH_PENDING_GENERAL_DC_IN_INWARD_SUCCESS = 'FETCH_PENDING_GENERAL_DC_IN_INWARD_SUCCESS';
export const FETCH_PENDING_GENERAL_DC_IN_INWARD_FAILURE = 'FETCH_PENDING_GENERAL_DC_IN_INWARD_FAILURE';

export const SET_ACTIVE_KEY_GENERAL_DC_INWARD_MASTER = 'SET_ACTIVE_KEY_GENERAL_DC_INWARD_MASTER';

export const NAVIGATE_TO_DETAIL_TAB = 'NAVIGATE_TO_DETAIL_TAB';

// *** ADMIN DC *** //
export const FETCH_ADMIN_DC_PENDING_MASTER_REQUEST = 'FETCH_ADMIN_DC_PENDING_MASTER_REQUEST';
export const FETCH_ADMIN_DC_PENDING_MASTER_SUCCESS = 'FETCH_ADMIN_DC_PENDING_MASTER_SUCCESS';
export const FETCH_ADMIN_DC_PENDING_MASTER_FAILURE = 'FETCH_ADMIN_DC_PENDING_MASTER_FAILURE';

export const FETCH_ADMIN_DC_INWARD_MASTER_REQUEST = 'FETCH_ADMIN_DC_INWARD_MASTER_REQUEST';
export const FETCH_ADMIN_DC_INWARD_MASTER_SUCCESS = 'FETCH_ADMIN_DC_INWARD_MASTER_SUCCESS';
export const FETCH_ADMIN_DC_INWARD_MASTER_FAILURE = 'FETCH_ADMIN_DC_INWARD_MASTER_FAILURE';




